import { Button, Group, Notification, Portal } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useRegisterSW } from 'virtual:pwa-register/react';

/** Hinweis „Neue Version verfügbar“ (PWA-08). */
export function PwaUpdatePrompt() {
  const { t } = useTranslation();
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW();

  if (!needRefresh) {
    return null;
  }

  return (
    <Portal>
      <Notification
        title={t('pwa.updateTitle')}
        onClose={() => setNeedRefresh(false)}
        style={{ position: 'fixed', bottom: 16, left: 16, zIndex: 1000, maxWidth: 360 }}
      >
        <Group justify="space-between" mt="xs">
          {t('pwa.updateText')}
          <Button size="xs" onClick={() => updateServiceWorker(true)}>
            {t('pwa.reload')}
          </Button>
        </Group>
      </Notification>
    </Portal>
  );
}
